import axios from "axios";
import router from '../../router.js';
import {_} from 'vue-underscore';

class ApiClasses {
    constructor() {
    }

    /**
     *
     * @param urls
     * @param user_key
     * @return {Promise<unknown[]>}
     */
    static async axiosGETWithUserKey(urls, user_key) {
        const promises = [];
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "user_key": user_key
            }
        }
        for (let url of urls) {
            promises.push(axios.get(url, config))
        }
        return await axios.all(promises)
    }

    /**
     *
     * @param apiURL
     * @param server_env
     * @return {Promise<*>}
     */
    static async getApps(apiURL, server_env) {
        const userkey = ApiClasses.get_USER_KEY();
        const url = apiURL + "app_list/getPortalApps?server_env=" + server_env;
        const responses = await ApiClasses.axiosGET([url], userkey)
        return responses[0].data;
    }

    /**
     * Use this to edit data for MTS roles
     * @param apiURL
     * @param mts_payload
     * @return {Promise<any>}
     */
    static async editMTSManagerInfo(apiURL, mts_payload) {
        //const mts_payload = {email: email.toLowerCase(), roles: rolesToRemove};
        const userkey = ApiClasses.get_USER_KEY();
        const url = apiURL + 'manage_mts_role/editData';
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "portal_key": userkey
            }
        }
        const response = await axios.put(url, mts_payload, config)
        console.log(response)
        return response.data
    }

    /**
     * Use this to add data to MTS roles
     * @param apiURL
     * @param mts_payload
     * @return {Promise<any>}
     */
    static async addMTSManagerInfo(apiURL, mts_payload) {
        //emails = ["email addresses to add"]
        //rolesToPost == [{email: email, role: r}]
        //whitelist_key = 'public'
        //const mts_payload = {"server": whitelist_key, whitelist: emails, roles: rolesToPost};
        const userkey = ApiClasses.get_USER_KEY();
        const url = apiURL + 'manage_mts_role/addData';
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "portal_key": userkey
            }
        }
        const response = await axios.post(url, mts_payload, config)
        return response.data
    }

    /**
     *
     * @param items
     * @return {*}
     */
    static sanitizeDAMPayload(items) {
        const roleNameToRoleMap = new Map();
        for (let roleNameObject of items) {
            roleNameObject.roles = [];
            roleNameToRoleMap.set(roleNameObject.email, roleNameObject);
        }
        for (let item of items) {
            const roleNameObject = roleNameToRoleMap.get(item.email);
            if (!roleNameObject) {
                continue;
            }
            if (!roleNameObject.roles.includes(item.role)) {
                roleNameObject.roles.push(item.role);
            }
        }
        return _.filter(items, function (item) {
            return ApiClasses.notEmpty(item.roles);
        });
    }

    /**
     *
     * @param apiURL
     * @return {Promise<*>}
     */
    static async fetchMTSManagers(apiURL) {
        const filter = {include: ["role"]};
        const manager_url = apiURL + 'mts_admin_manager?filter=' + JSON.stringify(filter);
        const mts_roles_url = apiURL + 'manage_mts_role/fetchData';
        const userkey = ApiClasses.get_USER_KEY();
        const responses = await ApiClasses.axiosGET([manager_url, mts_roles_url], userkey)
        let mts_managers = responses[0].data;
        const mts_payload = responses[1].data;

        const data_access_managers = ApiClasses.sanitizeDAMPayload(mts_payload);
        if (!Array.isArray(mts_managers)) {
            mts_managers = [mts_managers];
        }
        let manager_roles = [];
        for (let mts_manager of mts_managers) {
            const roles = mts_manager.role;
            if (ApiClasses.notEmpty(roles)) {
                manager_roles = [].concat(manager_roles, roles);
            }
        }
        manager_roles = _.uniq(manager_roles, function (role) {
            return role.role_id;
        });
        return {
            manager_roles: manager_roles,
            data_access_managers: data_access_managers
        }
    }

    /**
     *
     * @param response
     * @return {boolean}
     */
    static notEmpty(response) {
        if (response && response.length > 0) {
            return true;
        }
        return false;
    }

    /**
     *
     * @param urls
     * @param user_key
     * @returns {Promise<unknown[]>}
     */
    static async axiosGET(urls, user_key) {
        const promises = [];
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "portal_key": user_key
            }
        }
        for (let url of urls) {
            promises.push(axios.get(url, config))
        }
        return await axios.all(promises)
    }

    /**
     *
     * @param apiURL
     * @param email
     * @param password
     * @returns {Promise<*>}
     */
    static async login(apiURL, email, password) {
        const url = apiURL + 'registration/prism-portal-auth';
        const payload = {
            email: email,
            password: password
        };
        const res = await ApiClasses.axiosPost(url, null, payload);
        const dat = res.data;
        const parsed = JSON.stringify(dat);
        localStorage.setItem('user_info', parsed);
        return dat.api_key;
    }

    /**
     *
     * @param apiURL
     * @return {Promise<*>}
     */
    static async findScreens(apiURL) {
        const userKey = await ApiClasses.getTempApiKey(apiURL);
        const url = apiURL + "prism_screens";
        const res = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "user_key": userKey
            }
        });
        return res.data;
    }

    /**
     *
     * @param apiURL
     * @param screen
     * @return {Promise<*>}
     */
    static async findScreen(apiURL, screen) {
        const userKey = await ApiClasses.getTempApiKey(apiURL);
        const filter = {where: {name: screen}};
        const url = apiURL + "prism_screens?filter=" + JSON.stringify(filter);
        const res = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "user_key": userKey
            }
        });
        const foundScreen = res.data;
        if (foundScreen && foundScreen.length > 0) {
            //if user is not logged in, and screen includes closed
            if (foundScreen[0].status !== "ACTIVE") {
                throw "Screen '" + screen + "' is not an ACTIVE screen in CLUE";
            } else {
                return foundScreen[0];
            }
        }
        throw "Screen " + screen + " is not registered or not an ACTIVE screen in CLUE";
    }

    /**
     *
     * @param apiURL
     * @return {Promise<any>}
     */
    static async getCollaboratorList(apiURL) {
        const url = apiURL + "mts_institutions";
        const userKey = await ApiClasses.getTempApiKey(apiURL);
        const res = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "user_key": userKey
            }
        });
        return res.data;
    }

    /**
     *
     * @param apiURL
     * @param payload
     * @return {Promise<any>}
     */
    static async createAccount(apiURL, payload) {
        const url = apiURL + 'registration/register';
        const userKey = await ApiClasses.getTempApiKey(apiURL);
        const res = await axios.post(url, payload, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "user_key": userKey
            }
        });
        return res.data;
    }

    /**
     *
     * @param apiURL
     * @param payload
     * @return {Promise<any>}
     */
    static async postSubmission(apiURL, payload) {
        const url = apiURL + 'mts_compound_submissions/createSubmission';
        const userKey = await ApiClasses.getTempApiKey(apiURL);
        const res = await axios.post(url, payload, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "user_key": userKey
            }
        });
        return res.data;
    }

    /**
     *
     * @param apiURL
     * @param submission_type
     * @return {Promise<any>}
     */
    static async fetchSubmissionMessage(apiURL, submission_type) {

        let url = apiURL + 'prism_submission_window_message';
        if (submission_type) {
            const filter = {where: {submission_type: submission_type}};
            url = url + '?filter=' + JSON.stringify(filter);
        }
        const userKey = await ApiClasses.getTempApiKey(apiURL);
        const res = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "user_key": userKey
            }
        });
        return res.data;
    }

    /**
     *
     * @param apiURL
     * @param token
     * @return {Promise<any>}
     */
    static async confirmAccount(apiURL, token) {
        const url = apiURL + 'registration/confirm-registration/' + token;
        const userKey = await ApiClasses.getTempApiKey(apiURL);
        const res = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "user_key": userKey
            }
        });
        return res.data;
    }

    /**
     *
     * @param apiURL
     * @param payload
     * @return {Promise<any>}
     */
    static async passwordResetRequest(apiURL, payload) {
        const url = apiURL + 'registration/password-reset';
        const userKey = await ApiClasses.getTempApiKey(apiURL);
        const res = await axios.post(url, payload, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "user_key": userKey
            }
        });
        return res.data;
    }

    /**
     *
     * @param apiURL
     * @param payload
     * @return {Promise<any>}
     */
    static async passwordResetVerified(apiURL, payload) {
        const url = apiURL + 'registration/password-reset-verified';
        const userKey = await ApiClasses.getTempApiKey(apiURL);
        const res = await axios.post(url, payload, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "user_key": userKey
            }
        });
        return res.data;
    }

    /**
     *
     * @param url
     * @param api_key
     * @returns {Promise<*>}
     */
    static async getAPI(url, api_key) {
        const options = {
            method: 'GET',
            headers: {
                'user_key': api_key
            }
        };
        const response = await fetch(url, options)
        if (response.ok && response.status < 400) {
            return await response.json();
        }
        throw "url " + url + " not found";
    }

    /**
     *
     * @param apiURL
     * @return {Promise<*>}
     */
    static async getPublicResources(apiURL) {
        const userKey = await ApiClasses.getTempApiKey(apiURL);
        const filter = {fields: ["resource"]};
        const url = apiURL + "portal_public_resources?filter=" + JSON.stringify(filter);
        const resp = await ApiClasses.axiosGETWithUserKey([url], userKey);
        return _.uniq(_.pluck(resp[0].data, "resource"));
    }

    /**
     *
     * @param apiURL
     * @return {Promise<*>}
     */
    static async getTempApiKey(apiURL) {

        const config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }
        const url = apiURL.replace("/api/", "/") + 'temp_api_key';
        const resp = await axios.get(url, config);
        return resp.data.user_key;
    }

    /**
     *
     * @param resource
     * @param apiURL
     * @return {Promise<boolean>}
     */
    static async anonymousResources(resource, apiURL) {
        const anonResources = await ApiClasses.getPublicResources(apiURL);
        const re = new RegExp(anonResources.join("|"), "i");
        return re.test(resource);
    }

    /**
     *
     * @param url
     * @param user_key
     * @param payload
     * @returns {Promise<axios.AxiosResponse<any>>}
     */
    static async axiosPostAPIKey(url, user_key, payload) {
        if (user_key) {
            return await axios.post(url, payload, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "user_key": user_key
                    }
                }
            );
        }
        return await axios.post(url, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            }
        );
    }

    /**
     *
     * @param url
     * @param user_key
     * @param payload
     * @returns {Promise<axios.AxiosResponse<any>>}
     */
    static async axiosPost(url, user_key, payload) {
        if (user_key) {
            return await axios.post(url, payload, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "portal_key": user_key
                    }
                }
            );
        }
        return await axios.post(url, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            }
        );
    }

    /**
     *
     * @param project
     * @param file_url
     * @param api_url
     * @param user_key
     * @return {Promise<*>}
     */
    static async signFile(project, file_url, api_url, user_key) {
        let index = "";
        if (project) {
            const splits = file_url.split(project + "/");
            if (splits.length > 0) {
                index = "https://analysis.clue.io/" + splits[0] + "index.html";
            }
        }
        if (!index) {
            index = `https://analysis.clue.io/${project.toLowerCase()}/index.html`
        }

        const payload = {
            key: file_url,
            bucket: 'analysis.clue.io',
            index: index
        }

        const res = await ApiClasses.axiosPost(api_url, user_key, payload);
        return res.data
    }

    /**
     *
     * @param error
     * @param redirect_url
     */
    static handleAxiosError(error, redirect_url) {
        if (error.response) {
            console.log(error.response.status);
            if (error.response.status === 401) {
                //redirect to not authorized page
                console.log("Error message", error.response.data.error);
                router.push({path: '/notAuthorized'});
            } else if (error.response.status === 400) {
                router.push({path: '/notAuthorized'});
                //Display message on current page if there is one
            } else if (error.response.data && error.response.data.error && error.response.data.error.startsWith("jwt")) {
                localStorage.removeItem('user_info');
                console.log("jwt error")
                router.push({name: 'LoginPage', query: {redirect: redirect_url, jwt: "jwt"}});
            } else {
                console.log("Error message", error.response.data.error);
                router.push({path: '/notFound'});
            }
        } else if (error.request) {
            //response not received though the request was sent
            console.log(error.request);
        } else {
            //an error occurred when setting up the request
            console.log(error.message);
        }
    }

    /**
     *
     * @return {*|null}
     */
    static get_USER_KEY() {
        const user_info = localStorage.getItem('user_info');
        const user_info_parsed = JSON.parse(user_info);
        if (user_info_parsed) {
            return user_info_parsed.api_key;
        }
        return null;
    }

    /**
     *
     * @return {any}
     */
    static get_PARAMS() {
        const params = localStorage.getItem('params');
        return JSON.parse(params)
    }

    /**
     *
     * @return {any}
     */
    static get_PROJECT_RESOURCES() {
        const project = sessionStorage.getItem('project_resources');
        return JSON.parse(project)
    }

    /**
     *
     * @return {any}
     */
    static get_COMPOUND() {
        const compound = sessionStorage.getItem('compound');
        return JSON.parse(compound)
    }

    /**
     *
     * @return {string}
     */
    static get_SCREEN() {
        return localStorage.getItem('screen');
    }

    static get_COMPOUND_OVERVIEW() {
        const compound_overview = localStorage.getItem('compound_overview');
        return JSON.parse(compound_overview)
    }

    static userAuth() {
        let isAuth;
        if (localStorage.getItem('user_info')) {
            isAuth = true;
        } else {
            isAuth = false
        }
        return isAuth
    }

}

export default ApiClasses;

